export class ComplianceSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "compliantResources",
            "baseName": "compliantResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "notApplicableResources",
            "baseName": "notApplicableResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failuresByControl",
            "baseName": "failuresByControl",
            "type": "Array<ControlFailureCount>",
            "format": ""
        },
        {
            "name": "computedAt",
            "baseName": "computedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "perControlCompliance",
            "baseName": "perControlCompliance",
            "type": "Array<ControlComplianceEntry>",
            "format": ""
        },
        {
            "name": "groupBreakdowns",
            "baseName": "groupBreakdowns",
            "type": "Array<GroupBreakdown>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ComplianceSummary.attributeTypeMap;
    }
    constructor() {
    }
}
